import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { SalesChannelIface } from '../interfaces/sales-channel.iface';

@Injectable()
export class SalesChannelService {
  private readonly url: string;

  constructor(private http: HttpClient) {
    this.url = `${environment.SALES_CHANNEL_URL}`;
  }

  getChannels(): Observable<SalesChannelIface[]> {
    return this.http.get<SalesChannelIface[]>(this.url);
  }

  saveChannel(salesChannel: SalesChannelIface): Observable<SalesChannelIface> {
    return this.http.post<SalesChannelIface>(this.url, salesChannel);
  }

  removeChannel(channelId: string): Observable<SalesChannelIface> {
    return this.http.delete<SalesChannelIface>(`${this.url}/${channelId}`);
  }

  updateChannel(salesChannel: SalesChannelIface): Observable<SalesChannelIface> {
    return this.http.put<SalesChannelIface>(`${this.url}/${salesChannel._id}`, salesChannel);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sales-channel.service.ts